import { motion } from "framer-motion";
import { MessageCircle, ArrowDown } from "lucide-react";
import { IMAGES, TRIAL_WA, CONTACT, TAGLINE } from "../data/content";

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 30 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] },
});

export const Hero = () => (
  <section id="home" className="relative min-h-[100svh] flex items-center overflow-hidden noise-overlay" data-testid="hero-section">
    <div className="absolute inset-0">
      <img src={IMAGES.heroStadium} alt="" className="w-full h-full object-cover animate-kenburns opacity-60" />
      <img src={IMAGES.heroFire} alt="" className="absolute inset-0 w-full h-full object-cover mix-blend-screen opacity-50 animate-flicker" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-black/70 to-black/80" />
    </div>

    <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 pt-28 pb-20 sm:pt-32 sm:pb-24 w-full">
      <motion.p className="text-[10px] sm:text-xs tracking-[0.28em] uppercase text-[#D4AF37] font-semibold mb-6" {...fadeUp(0)} data-testid="hero-eyebrow">
        Home of Elite Football Development.
      </motion.p>

      <motion.h1 className="font-heading text-[38px] sm:text-6xl lg:text-7xl font-black uppercase tracking-tighter leading-[0.94] max-w-4xl" {...fadeUp(0.12)} data-testid="hero-headline">
        The New Era of <span className="text-[#D4AF37]">Football</span> is Here.
      </motion.h1>

      <motion.p className="mt-5 font-heading text-sm sm:text-lg font-bold uppercase tracking-[0.25em] text-[#D4AF37]" {...fadeUp(0.24)} data-testid="hero-motto">
        {TAGLINE}
      </motion.p>

      <motion.p className="mt-6 text-white/75 text-[15px] sm:text-lg max-w-xl leading-relaxed" {...fadeUp(0.36)} data-testid="hero-subtext">
        Elite football training for players aged 5-18. Developing intelligent, independent footballers through innovative, dynamic and purposeful drills that involve opposition and force quick decision making and demand high technical solutions.
      </motion.p>

      <motion.div className="mt-10 flex flex-col sm:flex-row flex-wrap gap-3" {...fadeUp(0.5)}>
        <a href={TRIAL_WA} target="_blank" rel="noreferrer" data-testid="hero-cta-trial"
          className="bg-[#D4AF37] text-black font-bold uppercase tracking-widest text-sm px-8 py-4 text-center transition-all duration-200 hover:bg-[#F3D059] hover:-translate-y-0.5 gold-glow">
          Book a Free Trial
        </a>
        <a href={CONTACT.whatsapp} target="_blank" rel="noreferrer" data-testid="hero-cta-whatsapp"
          className="inline-flex items-center justify-center gap-2 border border-[#D4AF37] text-[#D4AF37] font-bold uppercase tracking-widest text-sm px-8 py-4 hover:bg-[#D4AF37] hover:text-black transition-colors duration-200">
          <MessageCircle size={16} /> WhatsApp Us
        </a>
        <button
          onClick={() => document.querySelector("#training-groups")?.scrollIntoView({ behavior: "smooth" })}
          data-testid="hero-cta-groups"
          className="inline-flex items-center justify-center gap-2 text-white/70 font-semibold uppercase tracking-widest text-sm px-2 py-4 hover:text-[#D4AF37] transition-colors duration-200">
          Our Training Groups <ArrowDown size={14} />
        </button>
      </motion.div>
    </div>
  </section>
);
